import { AutoComplete, Flex, Typography } from 'antd';
import React, {
  useCallback, useContext, useEffect, useState,
} from 'react';
import { ModifierContext } from '../../../context';
import { getNormalizedFilteredModifiers } from '../../../utils';

function OptionSelector({
  option, setOption, width = '100%', selectedOptions,
}) {
  const { modifiers } = useContext(ModifierContext);
  const mapModifiersToOptions = useCallback((mods) => (
    (mods || []).map((mod) => ({
      id: mod.id,
      value: mod.title,
      label: mod.title,
      modifierOptions: mod.options,
    }))
  ), []);

  const buildNestedOptions = useCallback(
    () => mapModifiersToOptions(modifiers),
    [modifiers, mapModifiersToOptions],
  );

  const [nestedOptions, setNestedOptions] = useState(buildNestedOptions);

  useEffect(() => {
    setNestedOptions(
      buildNestedOptions().filter(
        (nested) => !selectedOptions?.find(
          (option) => (option.localId || option.modifiers_children?.[0]) === nested.id
            || option.modifiers_children?.[0]?.id === nested.id,
        ),
      ),
    );
  }, [selectedOptions, buildNestedOptions]);

  const onSelect = (_, selected) => {
    setOption({
      id: selected.id,
      value: selected.value,
      modifiers_children: [selected.id],
    });
  };

  const getSearchResult = (searchTerm) => (
    !searchTerm ? [] : mapModifiersToOptions(getNormalizedFilteredModifiers({ searchTerm, modifiers }))
  );
  return (
    <AutoComplete
      options={nestedOptions}
      style={{ width }}
      onSelect={onSelect}
      defaultValue={option}
      onChange={(value) => setOption({ value })}
      onSearch={(text) => setNestedOptions(getSearchResult(text))}
      placeholder="Write name then enter"
      dropdownStyle={{ width: 350 }}
      optionRender={(option) => (
        <Flex gap={4}>
          <Typography.Text>{option.data.value}</Typography.Text>
          <Typography.Text type="secondary" ellipsis>
            {option.data.modifierOptions?.map((opt) => opt.title)?.join(', ')}
          </Typography.Text>
        </Flex>
      )}
    />
  );
}
export default OptionSelector;
